
export type TSectionDouble = {
    title: string;
    data: string;
    newData?: string;
}

type TMiniCardsDoubleDataProps = {
    sections: TSectionDouble[];
}

const BASE_CLASS = "miniCards"
const MiniCardsDoubleData: React.FC<TMiniCardsDoubleDataProps> = ({ sections }) => {
    const localTheme = window.localStorage.getItem("theme") || "light";

    return (
        <div className={BASE_CLASS}>
            {sections.map((section: TSectionDouble) => 
                <div key={section.title} className={`${BASE_CLASS}__card__container ${localTheme}`}>
                    <div className={`${BASE_CLASS}__title__container`}>
                        <h5>{section.title.toUpperCase()}</h5>
                    </div>
                    <div className={`${BASE_CLASS}__text__container`}>
                        
                        <div className={`${BASE_CLASS}__text__box`}>
                            <h5>{section.data}</h5>
                            <h5>{section.newData}</h5>
                        </div>
                        {section.title.toUpperCase() !== "FECHA"
                            && <div className={`${BASE_CLASS}__info__container`}>
                                    <span>Original</span>
                                    <span>Nuevo</span>
                                </div>}
                    </div>
                </div>
            )}
        </div>
    );
}

export default MiniCardsDoubleData;